<script setup>
import {computed, onMounted, reactive, ref, watch} from 'vue'
import { useNotificationStore } from '@/stores/NotificationStore.js'

const props = defineProps({
    uuid: {
        type: String,
        required: true,
    },
})

const order = ref(null)
const loading = ref(false)
const syncing = ref(false)
const exporting = ref(false)
const lastRefundSync = ref(null)
const notificationStore = useNotificationStore()

const initialLoadDone = ref(false)

const loadOrder = async () => {
    loading.value = true
    const res = await axios.get(route('api.invoice-links.orders.show', props.uuid))
    order.value = res.data.order
    initialLoadDone.value = true
    loading.value = false
}

onMounted(() => {
    loadOrder()
})
</script>

<template>
    <div>
        <div class="md:sticky top-2 z-topbar">
            <frosted-bar>
                <div class="flex items-center justify-between space-x-4">
                    <h1>
                        {{ _mft('invoiceLink:purchase.domainNameSingular')}}
                        <span v-if="order">
                            #{{ order.invoice_reference }}
                        </span>
                    </h1>
                </div>
                <template #navigation>
                    <a :href="route('invoice-links.orders.index')">
                        &larr; {{ _mft('invoiceLink:purchase.domainNamePlural') }}
                    </a>

                </template>
            </frosted-bar>
        </div>

        <card-basic
            v-if="! loading && initialLoadDone"
        >
            <invoice-link-order-listitem
                :order="order"
                displaymode="expanded"
            />
        </card-basic>
        <mf-spinner-medium
            v-else
            class="w-24 h-12"
        />
    </div>
</template>

<style scoped>

</style>
